import { FunctionComponent } from 'react';
import { faObjectGroup, faTableList } from '@fortawesome/pro-duotone-svg-icons';
import { ConfigurationType, IConfigurationSection, LinkedProperties } from '@/utilities/forms/ConfigurationFormProcessor';
import ConfigurationItem, { IConfigurationExpandProps } from './ConfigurationItem';


const ConfigurationFormSection: FunctionComponent<IConfigurationSection & IConfigurationExpandProps> = ({ setExpanded, toggleExpand, expanded, ...item}) => {
    const {
        trialConfiguration,
        formSectionPropertyPath,
        formSectionMetadata,
        isGlobalConfiguration,
        isTrialConfiguration
    } = item;

    const isRepeating = !!formSectionMetadata?.repeating

    return (
        <ConfigurationItem
            toggleExpand={toggleExpand}
            setExpanded={setExpanded}
            expanded={expanded}
            spacing={isGlobalConfiguration ? 16 : 24}
            basePropertyPath={formSectionPropertyPath!}
            edit
            expandable
            enableable={!isTrialConfiguration && !isGlobalConfiguration}
            linkable={!isTrialConfiguration}
            linkedProperties={LinkedProperties[ConfigurationType.Section]}
            title={formSectionMetadata?.name ?? 'Unknown Section'}
            description={isRepeating ? 'Repeating' : undefined}
            type={isRepeating ? 'Collection' : 'Group'}
            typeIcon={isRepeating ? faTableList : faObjectGroup}
            item={item}
        />
    );
}

export default ConfigurationFormSection;